module.exports = __webpack_public_path__ + "static/img/jiuyifankui.3ca9da2f.png";